import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, Typography, useViewport } from '@chilecompra/react-kit'
import { handleKeyDown, useAccessibility } from '../../../modules/utils/accesibility'
import {
  DialogButtonContainer,
  DialogContainer,
  DialogQuestionsContainer,
  DialogSubContainer,
  InstitutionsList,
  InstitutionsListContainer,
  InstitutionsListItem,
  Link
} from './RegisterWizardWelcome.styles'
import { REACT_APP_AHESION_COVENANT_FILE_URL } from '../../../config/settings/environment'

/**
 * The Must be register's modal component.
 */
const MustBeRegisterModal = props => {
  const { open, onClose } = props
  const { size } = useViewport()
  const modalRef = useRef(null)

  useAccessibility(open, size, modalRef)

  const onHandleKeyDown = event => () => handleKeyDown(event, onClose)

  return (
    <>
      <Dialog
        onClose={onClose}
        open={open}
        maxWidth="800px"
        margin={size.isTiny ? '84px 18px auto 18px' : '0 auto'}
        padding="0"
        verticalAlign="center"
        aria-labelledby="debe-registrarse-modal-title"
        aria-describedby="debe-registrarse-modal-description"
        ref={modalRef}
      >
        <DialogContainer>
          <DialogSubContainer>
            <Typography
              tabIndex="0"
              id="debe-registrarse-modal-title"
              fontWeight="bold"
              variant="h3"
              textAlign={size.isTiny ? 'left' : 'center'}
            >
              ¿Cómo saber si mi institución debe registrarse en Mercado Público?
            </Typography>
            <Typography
              tabIndex="0"
              id="debe-registrarse-modal-description"
              marginTop={size.isTiny ? '21px' : '32px'}
              variant="body2"
              textAlign="left"
            >
              A continuación podrás revisar el listado de instituciones comprendidas en el artículo 1 y el artículo 3
              bis de la ley N° 19.886 de compras públicas.
            </Typography>

            <InstitutionsListContainer>
              <InstitutionsList>
                <InstitutionsListItem tabIndex="0">
                  Organismo de la Administración del Estado(art.1 iniciso 2° LOCBGAE)
                </InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">Corporaciones Municipales</InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">Fundaciones de la Presidencia</InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">
                  Corporaciones con participación de la Administración del Estado, que reciban asignaciones públicas
                  sobre 1.500 UTM, identificadas por D.S
                </InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">Congreso Nacional</InstitutionsListItem>
              </InstitutionsList>
              <InstitutionsList>
                <InstitutionsListItem tabIndex="0">Poder Judicial</InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">CGR</InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">Ministero Público</InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">
                  TC, TDLC, TRICEL, Tribunales Electorales Regionales, Tribunales Ambientales
                </InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">SERVEL</InstitutionsListItem>
                <InstitutionsListItem tabIndex="0">CNTV</InstitutionsListItem>
              </InstitutionsList>
            </InstitutionsListContainer>
          </DialogSubContainer>
          <DialogQuestionsContainer>
            <Typography tabIndex="0" fontWeight="bold" margin="24px 0 0" variant="body2" textAlign="left">
              Si tu institución no forma parte del listado, puedes realizar un registro voluntario en Mercado Público
            </Typography>
            <Typography tabIndex="0" margin="14px 0 0" variant="body2" textAlign="left">
              Para registrar tu institución de forma voluntaria debes utilizar el formulario de registro, considerando
              que quien tenga la representación de tu institución deberá firmar el siguiente{' '}
              <Link
                href={REACT_APP_AHESION_COVENANT_FILE_URL}
                color="primary"
                target="_blank"
                tabIndex="0"
                aria-label="convenio de adhesión"
                rel="noopener noreferrer"
                underline="true"
              >
                convenio de adhesión
              </Link>{' '}
              mediante el uso de Clave Única.
            </Typography>
            <Typography tabIndex="0" fontWeight="bold" margin="16px 0 0" variant="body2" textAlign="left">
              ¿Qué se entiende por autoridad con poder de representación?
            </Typography>
            <Typography tabIndex="0" margin="14px 0 0" variant="body2" textAlign="left">
              Es la persona natural que tiene la facultad para obligar a la institución que representa, a través de su
              firma. Por ejemplo, en una municipalidad, es el alcalde electo, mientras que en una corporación municipal,
              el director de la misma.
            </Typography>
          </DialogQuestionsContainer>
          <DialogButtonContainer>
            <Button tabIndex="0" aria-label="Cerrar" color="default" onClick={onClose} onKeyDown={onHandleKeyDown}>
              Cerrar
            </Button>
          </DialogButtonContainer>
        </DialogContainer>
      </Dialog>
    </>
  )
}

MustBeRegisterModal.defaultProps = {
  onClose: () => undefined,
  open: false
}

MustBeRegisterModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool
}

export default MustBeRegisterModal
